import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

interface HeroButtonProps {
  onClick: () => void;
}

export default function HeroButton({ onClick }: HeroButtonProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
      className="mt-8 flex justify-center lg:justify-start"
    >
      <button 
        onClick={onClick}
        className="group bg-[#ee99ea] text-dark px-8 py-3 rounded-lg hover:bg-[#f0a5ec] transition-all duration-300 transform hover:-translate-y-1 flex items-center space-x-2 shadow-lg hover:shadow-xl"
      >
        <span className="font-medium">Start My Growth Journey</span>
        <ArrowRight className="w-4 h-4 text-[#151b59] group-hover:translate-x-1 transition-transform" />
      </button>
    </motion.div>
  );
}